import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("dgnbp"), parcelRequire.load("j2VIL"), parcelRequire.load("g56vt"), parcelRequire.load("dsIXS"), parcelRequire.load("i0M0K"), parcelRequire.load("iwx79"), parcelRequire.load("8WlTG"), parcelRequire.load("d4VSw"), parcelRequire.load("8L9rh"), parcelRequire.load("16eHg"), parcelRequire.load("lH05e"), parcelRequire.load("45RYB"), parcelRequire.load("6ZqMg"), parcelRequire.load("dRxJe")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("dgnbp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("j2VIL")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dsIXS")} />
  <link rel="modulepreload" href={parcelRequire.resolve("i0M0K")} />
  <link rel="modulepreload" href={parcelRequire.resolve("iwx79")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8WlTG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("d4VSw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8L9rh")} />
  <link rel="modulepreload" href={parcelRequire.resolve("16eHg")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lH05e")} />
  <link rel="modulepreload" href={parcelRequire.resolve("45RYB")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6ZqMg")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dRxJe")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
